import { __exports as ToDurationRecord } from "../../../../../_virtual/ToDurationRecord.mjs";
import { __require as requireIsValidDurationRecord } from "./IsValidDurationRecord.mjs";
import { __require as requireToIntegerIfIntegral } from "./ToIntegerIfIntegral.mjs";
var hasRequiredToDurationRecord;
function requireToDurationRecord() {
  if (hasRequiredToDurationRecord) return ToDurationRecord;
  hasRequiredToDurationRecord = 1;
  Object.defineProperty(ToDurationRecord, "__esModule", { value: true });
  ToDurationRecord.ToDurationRecord = void 0;
  var IsValidDurationRecord_1 = requireIsValidDurationRecord();
  var ToIntegerIfIntegral_1 = requireToIntegerIfIntegral();
  function ToDurationRecord$1(input) {
    if (typeof input !== "object") {
      if (typeof input === "string") {
        throw new RangeError("Invalid duration format");
      }
      throw new TypeError("Invalid duration");
    }
    var result = {
      years: 0,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      microseconds: 0,
      nanoseconds: 0
    };
    if (input.days !== void 0) {
      result.days = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.days);
    }
    if (input.hours !== void 0) {
      result.hours = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.hours);
    }
    if (input.microseconds !== void 0) {
      result.microseconds = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.microseconds);
    }
    if (input.milliseconds !== void 0) {
      result.milliseconds = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.milliseconds);
    }
    if (input.minutes !== void 0) {
      result.minutes = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.minutes);
    }
    if (input.months !== void 0) {
      result.months = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.months);
    }
    if (input.nanoseconds !== void 0) {
      result.nanoseconds = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.nanoseconds);
    }
    if (input.seconds !== void 0) {
      result.seconds = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.seconds);
    }
    if (input.weeks !== void 0) {
      result.weeks = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.weeks);
    }
    if (input.years !== void 0) {
      result.years = (0, ToIntegerIfIntegral_1.ToIntegerIfIntegral)(input.years);
    }
    if (input.years === void 0 && input.months === void 0 && input.weeks === void 0 && input.days === void 0 && input.hours === void 0 && input.minutes === void 0 && input.seconds === void 0 && input.milliseconds === void 0 && input.microseconds === void 0 && input.nanoseconds === void 0) {
      throw new TypeError("Invalid duration format");
    }
    if (!(0, IsValidDurationRecord_1.IsValidDurationRecord)(result)) {
      throw new RangeError("Invalid duration format");
    }
    return result;
  }
  ToDurationRecord.ToDurationRecord = ToDurationRecord$1;
  return ToDurationRecord;
}
export {
  requireToDurationRecord as __require
};
